import Talent from './talent';
import { Talents, TalentField, Category } from '../character/allValues';
import TalentFieldObject from './talentFieldObject';

export default class TalentCollection {
  public allTalents: Talent[] = Talents;

  public getAllTalentFields(): TalentFieldObject[] {
    return [
      { name: 'Körper', id: TalentField.Körper },
      { name: 'Gasse', id: TalentField.Gasse },
      { name: 'Geist', id: TalentField.Geist },
      { name: 'Mystik', id: TalentField.Mystik },
      { name: 'Wildnis', id: TalentField.Wildnis },
      { name: 'Wissen', id: TalentField.Wissen },
    ];
  }

  public getTalentsByTalentField(field: TalentField) {
    return this.allTalents.filter((talent) => talent.talentField === field);
  }

  public getTalentByAbbreviation(abbreviation: string): Talent {
    const foundTalent = this.allTalents.find((talent) => talent.abbreviation === abbreviation);

    if (typeof foundTalent === 'undefined') {
      throw new Error('Talent with abbreviation ' + abbreviation + ' not found in allTalents');
    }

    return foundTalent.getClone();
  }

  public getCategoryByAbbreviation(abbreviation: string) {
    if (this.allTalents.findIndex((resource) => resource.abbreviation === abbreviation) > -1) {
      return Category.Talent;
    }
    return null;
  }

  get allValues() {
    return this.allTalents;
  }
}
